import { useEffect, useSyncExternalStore } from 'react';

/** Lets a detail page contribute the last breadcrumb (e.g. a tenant's name). */
let tail: string | null = null;
const listeners = new Set<() => void>();

function set(next: string | null) {
  tail = next;
  for (const l of listeners) l();
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useCrumbTail(): string | null {
  return useSyncExternalStore(
    subscribe,
    () => tail,
    () => tail,
  );
}

export function useSetCrumbTail(label: string | null | undefined): void {
  useEffect(() => {
    set(label ?? null);
    return () => set(null);
  }, [label]);
}
